// ***__***_________  BIBLIOTECAS _________ ***__***
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { map, takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormArray, FormGroup, AbstractControl, FormControl, FormArray, UntypedFormControl } from '@angular/forms';

// ***__***_________  SERVICOS _________ ***__***
import { TranslateService } from '@ngx-translate/core';
import { CostCenterConfigService } from '../../../services/costCenterConfig.service';
import { TranslateValueService } from '../../../services/translate-value.service';

// ***__***_________  VARIAVEIS GLOBAIS _________ ***__***
import { CURRENCY_DECIMAL, PERCENTAGE_DECIMAL, revertFormat, ROLES } from '../../../constants/global';

// ***__***_________  MODELOS _________ ***__***
import { ChooseModalParam } from 'src/app/models/choose-modal-param';

// ***__***_________  MODALS _________ ***__***
import { ChooseModalComponent } from '../choose-modal/choose-modal.component';

// ***__***_________  MODULOS _________ ***__***
import { ErrorTreatmentFunctions } from '../../../modules/treatments.module';
import { CostCenter, ModulesCostCenterUserEnum } from 'src/app/models/costCenter';
import { Dropdown } from 'src/app/models/dropdown';
import { DropDownService } from 'src/app/services/dropDown.service';
import { CostCenterDistribution, CostCenterDistributionCustomColumns } from 'src/app/models/cost-center-distribution';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CostCenterDistributionHelper } from './costCenter-distribution-helper';
import { forkJoin, Subject } from 'rxjs';
import { CostCenterDistributionService } from 'src/app/services/costCenterDistribution.service';

declare var Functions: any;

@Component({
  templateUrl: './costCenter-distribution-modal.html',
  styles: [
    '.mb-0 { margin-bottom:0px !important }',
    '.text-black { color: #000 !important }',
    '.border-top-foot { border-top: 1px solid #ddd }'
  ],
})
export class CostCenterDistributionModalComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  
  isDisabled: boolean;
  companyID: number;
  totalNetAmount: number;
  totalNetAmountString: string;

  backendSave: boolean = false;
  entityID: number;
  context: string;

  form: UntypedFormGroup;
  currentLanguage: string;

  customColumns: CostCenterDistributionCustomColumns[] = [];
  showElement: boolean = false;
  showRubric: boolean = false;

  allRubricaList: Dropdown[] = [];
  rubricaList: Dropdown[][] = [];

  allElementoList: Dropdown[] = [];
  elementoList: Dropdown[][] = [];

  allCostCenters: CostCenter[] = [];
  costCentersFiltered: CostCenter[] = [];

  //filtros dos centros de custo
  deliveryLocationID: number;
  documentType: string;

  constructor(public dialogRef: MatDialogRef<CostCenterDistributionModalComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private translateService: TranslateService,
    private translateValueService: TranslateValueService,
    private formBuilder: UntypedFormBuilder,
    private costCenterConfigService: CostCenterConfigService,
    private authenticationService: AuthenticationService,
    private dialog: MatDialog,
    private _serviceDD: DropDownService,
    private _helper: CostCenterDistributionHelper,
    private _service: CostCenterDistributionService) 
  {
    this.currentLanguage = this.translateValueService.translateLanguage;

    this.form = this.formBuilder.group({
      'CostCenterDistribution': this.formBuilder.array([]),
      'SumValue': [(0).formatDecimal(this.currentLanguage, (+CURRENCY_DECIMAL))],
      'SumPercentage': [(0).formatDecimal(this.currentLanguage, (+CURRENCY_DECIMAL))],
      'SumPercentageNumber': [0]
    });

    // parametros que vai receber
    this.isDisabled = data.isDisabled;
    this.context = data.context;
    this.entityID = data.entityID;
    this.totalNetAmount = data.totalNetAmount ?? 0;

    this.totalNetAmountString = this.totalNetAmount.formatDecimal(this.currentLanguage, (+CURRENCY_DECIMAL));
    this.backendSave = data.backendSave || false;

    this.showRubric = data.customColumns?.some(x => x.name == 'RubricID')
    this.showElement = data.customColumns?.some(x => x.name == 'ElementID')
    this.customColumns = data.customColumns || [];

    this.companyID = data.companyID ?? this.authenticationService.session.company.ID;

    //Componente é genérico e os contratos usa ngModel
    if (data.costCenterDistributionList instanceof UntypedFormArray && data.costCenterDistributionList.controls.length > 0){
      (<UntypedFormArray>this.form.get('CostCenterDistribution')).controls = data.costCenterDistributionList.controls;
    }else if (data.costCenterDistributionList instanceof Array){
      this.buildForm(data.costCenterDistributionList)
    }

    if (this.isDisabled)
      this.form.get('CostCenterDistribution').disable();

    let obs = this.getDropDownLists();

    //Existem utilizadores qeu são de consulta que podem não ter acesso ao centro de custo, logo, se estiver disabled vai buscar todos
    obs.push(this.costCenterConfigService.getuserCostCenters(this.isDisabled ? false : !(this.authenticationService.session.roles.some(x => x === ROLES.USER_ADMIN)), false, this.companyID, [ModulesCostCenterUserEnum.Orders]).pipe(map((response: Array<any>) => this.allCostCenters = response)))
    
    forkJoin(obs).pipe(takeUntil(this.destroy$)).subscribe(() => { 
      this.costCentersFiltered = this.allCostCenters.filter(r => !r.Inactive);

      this.CostCenterDistribution.controls.forEach((f: FormGroup) => {
        if (!f.get("CostCenterID")?.value){
          if (this.showRubric && f.get("RubricID"))
            f.get("RubricID").disable()
    
          if (this.showElement && f.get("ElementID"))
            f.get("ElementID").disable()
        }else{
          this.rubricaList.push(this.allRubricaList.filter(x => x.ParentCode === f.get("CostCenterID").value?.toString()))
          this.elementoList.push(this.allElementoList.filter(x => x.ParentCode === f.get("CostCenterID").value?.toString()))
          f.controls["CostCenterName"].setValue(f.get("CostCenterID").value ? this.allCostCenters.find(x => x.ID == f.get("CostCenterID").value)?.Name ?? 'Not Found' : null);
        }
      })

      this.calcSums();
    })
  }

  // Getter para facilitar o acesso ao FormArray no template
  get CostCenterDistribution(): FormArray {
    return this.form.get('CostCenterDistribution') as FormArray;
  }

  getFormItemFieldControl(i: number, name: string): FormControl {
    return <FormControl>(<UntypedFormArray>this.form.get('CostCenterDistribution')).controls[i].get(name)
  }

  ngOnInit(): void {
    
  }

  buildForm(list: CostCenterDistribution[]): void {
    list.forEach((e: CostCenterDistribution) => {
      this.CostCenterDistribution.push(this._helper.Create(e, this.isDisabled, this.customColumns))
    });
  }

  getDropDownLists(): any[] {
    let observables = [];

    if (this.showRubric)
      observables.push(this._serviceDD.GetDropdownData(Dropdown.RUBRIC, null, false).pipe(map((response: Array<any>) => this.allRubricaList = response)));

    if (this.showElement)
      observables.push(this._serviceDD.GetDropdownData(Dropdown.ELEMENT, null, true).pipe(map((response: Array<any>) => this.allElementoList = response)));

    return observables;
  }

  costCenterChange(costcenter: CostCenter, index: number){
    if (this.showRubric)
      this.rubricaList[index] = this.allRubricaList.filter(x => x.ParentCode === costcenter.ID.toString())

    if (this.showElement)
      this.elementoList[index] = this.allElementoList.filter(x => x.ParentCode === costcenter.ID.toString())
  }


  //Adiciona
  add() {
    let control = this._helper.Create(null, this.isDisabled, this.customColumns);

    if (!(this.form.get("CostCenterID")?.value)){
      if (this.showRubric && this.form.get("RubricID"))
        this.form.get("RubricID").disable()

      if (this.showElement && this.form.get("ElementID"))
        this.form.get("ElementID").disable()
    }

    this.CostCenterDistribution.push(control);

    //Se a soma da percentagem for inferior a 100, cria  nova linha com o restante, se não dá reset e divide a percentagem pelas linhas todas
    let perc = this.CostCenterDistribution.controls.reduce((sum, x: FormGroup) => sum + x.controls["Percentage"].value.toString().revertDecimal(), 0);
    if (perc < 100)
    {
      let newPercentage = 100-perc;
      control.get("Percentage").setValue(100-perc);
      // Calcula o novo valor com base na porcentagem alterada
      const newValue = (this.totalNetAmount * newPercentage) / 100;

      // Define o novo valor e porcentagem para a linha selecionada
      control.controls["Percentage"].setValue(newPercentage.formatDecimal(this.currentLanguage, (+PERCENTAGE_DECIMAL)));
      control.controls["Value"].setValue(newValue.formatDecimal(this.currentLanguage, (+CURRENCY_DECIMAL)));
    }else{
      this.setEqualPercentageAndValue();
    }
    
    this.form.updateValueAndValidity();
    this.calcSums();
  }

  //Atualiza as linhas todas com a mesma percentagem e valor
  //Ultima linha fica com a diferença por causa de arrendondamentos
  setEqualPercentageAndValue() {
    const numItems = this.CostCenterDistribution.length;

    // Calcula a percentagem e o valor base (arredondando para baixo para evitar exceder o total)
    const basePercentage = Math.floor((100 / numItems) * 100) / 100; // Percentagem base arredondada
    const baseValue = Math.floor((this.totalNetAmount / numItems) * 100) / 100; // Valor base arredondado

    let totalAssignedPercentage = 0;
    let totalAssignedValue = 0;

    // Define os valores base para cada item
    this.CostCenterDistribution.controls.forEach((x: FormGroup, index: number) => {
        const isLastItem = index === numItems - 1;

        let percentage = isLastItem 
            ? revertFormat((100 - totalAssignedPercentage).formatDecimal(this.currentLanguage, (+PERCENTAGE_DECIMAL)))
            : basePercentage;

        let value = isLastItem 
            ? revertFormat((this.totalNetAmount - totalAssignedValue).formatDecimal(this.currentLanguage, (+PERCENTAGE_DECIMAL)))
            : baseValue;

        // Acumula os valores atribuídos
        totalAssignedPercentage += percentage;
        totalAssignedValue += value;

        // Atualiza os controles do formulário
        x.controls["Percentage"].setValue(percentage.formatDecimal(this.currentLanguage, (+PERCENTAGE_DECIMAL)));
        x.controls["Value"].setValue(value.formatDecimal(this.currentLanguage, (+CURRENCY_DECIMAL)));
    });

    this.calcSums();
  }

  // quando altera percentagem, calcula o valor
  onChangePercentage(newValueString: string, i: number) {

    if (this.CostCenterDistribution.at(i).get("Percentage").invalid || this.CostCenterDistribution.at(i).get("Value").invalid)
      return;

    let newPercentage = revertFormat(newValueString)

    if (newPercentage == null)
      return;
    
    const currentControl = this.CostCenterDistribution.at(i) as FormGroup;

    // Calcula o novo valor com base na porcentagem alterada
    const newValue = (this.totalNetAmount * newPercentage) / 100;

    // Define o novo valor e porcentagem para a linha selecionada
    currentControl.controls["Percentage"].setValue(newPercentage.formatDecimal(this.currentLanguage, (+PERCENTAGE_DECIMAL)));
    currentControl.controls["Value"].setValue(newValue.formatDecimal(this.currentLanguage, (+CURRENCY_DECIMAL)));

    this.calcSums();
  }

  // quando altera valor, caulcula a percentagem com base no valor total do documento/linha
  onChangeValue(newValueString: string, i: number) {

    if (this.CostCenterDistribution.at(i).get("Percentage").invalid || this.CostCenterDistribution.at(i).get("Value").invalid)
      return;

    let newValue = revertFormat(newValueString)

    const currentControl = this.CostCenterDistribution.at(i) as FormGroup;

    // Define o novo valor e calcula a porcentagem correspondente
    const newPercentage = (newValue / this.totalNetAmount) * 100;
    currentControl.controls["Value"].setValue(newValue.formatDecimal(this.currentLanguage, (+CURRENCY_DECIMAL)));
    currentControl.controls["Percentage"].setValue(newPercentage.formatDecimal(this.currentLanguage, (+PERCENTAGE_DECIMAL)));

    // Calcula o total restante a ser redistribuído
    // const remainingTotal = this.totalNetAmount - newValue;
    // const otherControls = this.CostCenterDistribution.controls.filter((_, indice) => indice !== i) as FormGroup[];

    // // Recalcula as pércentagens e valores para as outras linhas proporcionalmente
    // otherControls.forEach((control) => {
    //   const oldValue = revertFormat(control.controls["Value"].value);
    //   const adjustedValue = remainingTotal / otherControls.length;

    //   control.controls["Value"].setValue(adjustedValue.formatDecimal(this.currentLanguage, (+CURRENCY_DECIMAL)));
    //   control.controls["Percentage"].setValue(((adjustedValue / this.totalNetAmount) * 100).formatDecimal(this.currentLanguage, (+PERCENTAGE_DECIMAL)));
    // });
    this.calcSums();
  }

  // remover linha
  remove(i: number) {
    this.CostCenterDistribution.removeAt(i);

    if (this.showElement)
      this.elementoList.splice(i)

    if (this.showRubric)
      this.rubricaList.splice(i)

    this.setEqualPercentageAndValue();
  }

  // guardar lista de distribuições
  onSubmit() {
    this.calcSums();

    this.form.markAllAsTouched();

    if (this.form.invalid)
      return;

    let sumPercentage = 0;
    let sumValue = 0;
    let errorMsg = '';
    const uniqueCombinations = new Set<string>();
    let hasDuplicates = false;

    // Calcula o somatório de percentagens e valores
    this.CostCenterDistribution.controls.forEach((x: FormGroup) => {

      //Validação de duplicações
      const costCenterID = x.controls['CostCenterID']?.value;
      const rubricID = this.showElement ? x.controls['RubricID']?.value : null;
      const elementID = this.showElement ? x.controls['ElementID']?.value : null;

      // Cria uma chave única para a combinação
      const combinationKey = `${costCenterID}-${rubricID}-${elementID}`;

      if (uniqueCombinations.has(combinationKey)) {
          hasDuplicates = true;
      } else {
          uniqueCombinations.add(combinationKey);
      }

      // Calcula o somatório de percentagens e valores
      sumPercentage += revertFormat(x.controls["Percentage"].value);
      sumValue += revertFormat(x.controls["Value"].value);
    });

    if (this.CostCenterDistribution.controls.length > 0) {
        if (sumPercentage !== 100) {
            errorMsg += this.translateValueService.get('THE_PERCENTAGE_MUST_MUST_BE_EQUAL_TO_100_PERCENT') + '<br/>';
        }

        if (sumValue !== Number(this.totalNetAmount)) {
            errorMsg += this.translateValueService.get('SUM_DIFF_FROM_DOCUMENT', { value: sumValue.toFixed(2) + '€', value2: this.totalNetAmount.toString() + '€' }) + '<br/>';
        }
    }

    if (hasDuplicates) {
      errorMsg += this.translateValueService.get('DUPLICATE_VALUES_DETECTED') + '<br/>';
    } 

    if (errorMsg) {
      Functions.gritter(errorMsg, 'danger');
      return;
    }

    //Guarda as alterações diretamente no backend - Faturas
    if (this.backendSave && this.context){

      let ccds: CostCenterDistribution[] = [];
      this.CostCenterDistribution.controls.forEach((x: FormGroup) => {
        let ccd = x.getRawValue() as CostCenterDistribution;
        ccd.Percentage = revertFormat(x.controls.Percentage.value.toString())
        ccd.Value = revertFormat(x.controls.Value.value.toString())
        ccds.push(ccd);
      })

      this._service.updateCostCenterDistributions(this.entityID, this.context, ccds).subscribe(x => {
        if (x.ReturnStatus.Successfull) {
          Functions.gritter(x.ReturnStatus.SuccessMessage, 'success');
          this.dialogRef.close();
        }
        else
          Functions.gritter(x.ReturnStatus.ErrorMessage, 'danger');
      })
    }else{
      this.dialogRef.close(this.CostCenterDistribution);
    }
  }

  // modal centros de custo
  selectCostCenter(i: number) {
    this.translateService.get(['SELECT_COST_CENTER', 'CODE', 'NAME']).subscribe(response => {
      let aoColumns = [
        { 'data': 'ID' }, // 0
        { 'data': 'IntegrationID', 'class': 'verticalMiddle', 'title': response['CODE'], }, // 1 - código
        { 'data': 'Name', 'class': 'verticalMiddle', 'title': response['NAME'] }, // 2 - nome
      ];

      let columnDefs = [
        { 'targets': [0], 'visible': false }, // colocar como hidden
        { 'targets': [-1], 'orderable': false }, // nao permitir ordenar pelas colunas
      ],

        dialogRef = this.dialog.open(ChooseModalComponent, {
          data: // dados que vai enviar para o componente da modal
            new ChooseModalParam(this.costCentersFiltered, null, response['SELECT_COST_CENTER'], aoColumns, columnDefs, null, 1, null),
          disableClose: true, // nao permitir fechar modal com escape ou clique fora
        });

      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          let costCenterSelected = this.costCentersFiltered.find(x => x.ID == result);
          this.getFormItemFieldControl(i, "CostCenterID").setValue(result);
          this.getFormItemFieldControl(i, "CostCenterName").setValue(costCenterSelected?.Name ?? 'Not Found');

          if (this.showRubric)
            this.getFormItemFieldControl(i, "RubricID").setValue(null);

          if (this.showElement)
            this.getFormItemFieldControl(i, "ElementID").setValue(null);

          this.costCenterChange(costCenterSelected, i);
          this.form.markAllAsTouched();
          this.form.updateValueAndValidity();
          this.CostCenterDistribution.updateValueAndValidity();
        }
      });
    });
  }

  recalc(type: boolean){
    if (type)
      this._helper.updateValuesBasedOnPercentages(this.CostCenterDistribution, this.totalNetAmount);
    else
      this._helper.updateValuesBasedOnValues(this.CostCenterDistribution, this.totalNetAmount);

    this.calcSums();
  }

  //Calcula os totais 
  calcSums(){
    let sumValue = 0;
    let sumPercentage = 0;

    this.CostCenterDistribution.controls.forEach((f: FormGroup) => {
      sumValue += revertFormat(f.get("Value")?.value.toString())
      sumPercentage += revertFormat(f.get("Percentage")?.value.toString())
    })

    this.form.get("SumValue").setValue(sumValue.formatDecimal(this.currentLanguage, (+CURRENCY_DECIMAL)));
    this.form.get("SumPercentage").setValue(sumPercentage.formatDecimal(this.currentLanguage, (+PERCENTAGE_DECIMAL)));
    this.form.get("SumPercentageNumber").setValue(revertFormat(sumPercentage.formatDecimal(this.currentLanguage, (+PERCENTAGE_DECIMAL))));
    this.CostCenterDistribution.updateValueAndValidity();
  }

  ngOnDestroy() { }
}